<div class="modal-header" id="subscribe-push-notification-modal-title">
    <div class="modal-header-content">
        <h3>Enable PACE Push Notifications</h3>
        <p>
            PACE wants to send you important alerts and updates. To receive them, we need your permission for push
            notifications.
        </p>
        <p>View the example below to see where your browser will ask for permission.</p>
    </div>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    <div class="row visual-guide-image"></div>
</div>
<p>Click <strong>Enable Notifications</strong> below to proceed. Your browser will then ask for permission.</p>

<div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="triggerPushNotificationSubscribe()">
        Enable Notifications
    </button>
</div>
